{
  "common": {
    "appName": "Qahvadosh Admin",
    "loading": "Yuklanmoqda…",
    "save": "Saqlash",
    "cancel": "Bekor qilish",
    "close": "Yopish",
    "apply": "Qo'llash",
    "reset": "Tozalash",
    "search": "Qidirish",
    "filter": "Filtr",
    "actions": "Amallar",
    "details": "Batafsil",
    "confirm": "Tasdiqlash",
    "yes": "Ha",
    "no": "Yo'q",
    "all": "Barchasi",
    "from": "dan",
    "to": "gacha",
    "sum": "so'm",
    "coffee": "qahva",
    "coffeeCount": "{{count}} qahva",
    "theme": "Ko'rinish",
    "themeLight": "Yorug'",
    "themeDark": "Qorong'i",
    "themeSystem": "Tizim",
    "language": "Til",
    "logout": "Chiqish",
    "copy": "Nusxalash",
    "copied": "Nusxalandi",
    "never": "Hech qachon",
    "today": "Bugun",
    "week": "Hafta",
    "month": "Oy",
    "quarter": "Chorak",
    "minutesShort": "{{count}} daq",
    "duration": "Davomiylik",
    "edit": "Tahrirlash",
    "delete": "O'chirish",
    "logoutTitle": "Chiqasizmi?",
    "logoutBody": "Sessiya yopiladi va siz saytga qaytasiz. Panelga qaytish uchun qaytadan kirasiz.",
    "back": "Orqaga",
    "day": "Kun",
    "year": "Yil"
  },
  "nav": {
    "dashboard": "Statistika",
    "analytics": "Analitika",
    "users": "Foydalanuvchilar",
    "invitations": "Takliflar",
    "ledger": "Hisob (ledger)",
    "payments": "To'lovlar",
    "withdrawals": "Chiqarishlar",
    "reports": "Shikoyatlar",
    "hostApplications": "Mezbon arizalari",
    "settings": "Sozlamalar",
    "openMenu": "Menyuni ochish",
    "roles": "Rollar",
    "reference": "Ma'lumotnomalar",
    "referenceIndustries": "Sohalar",
    "referenceRegions": "Viloyatlar",
    "referenceDistricts": "Tumanlar",
    "finance": "Pul",
    "settingsPlatform": "Platforma",
    "settingsMeetings": "Uchrashuvlar",
    "audit": "Audit jurnali",
    "promo": "Promo kodlar",
    "payouts": "Soliq profillari",
    "live": "Efirlar",
    "reviews": "Sharhlar",
    "messages": "Xabarlar"
  },
  "auth": {
    "checking": "Sessiya tekshirilmoqda…",
    "signInRequired": "Kirish talab qilinadi",
    "signInHint": "Admin panelga kirish uchun asosiy saytdan Telegram orqali kiring. Sessiya ikkala saytda ham amal qiladi.",
    "goToLogin": "Kirish sahifasiga",
    "stepOne": "Asosiy saytda Telegram orqali kiring",
    "stepTwo": "Tasdiqlangach shu sahifaga qayting",
    "stepThree": "Panel avtomatik ochiladi",
    "sessionNote": "Parol yo'q: sessiya xavfsiz cookie'da saqlanadi va ikkala saytda amal qiladi.",
    "backToSite": "Asosiy saytga qaytish",
    "networkHint": "Server javob bermayapti. Aloqani tekshirib, qayta urinib ko'ring.",
    "retry": "Qayta urinish",
    "forbiddenTitle": "Ruxsat yo'q",
    "forbiddenHint": "Bu bo'lim uchun sizda ruxsat yo'q. Kerak bo'lsa, tizim egasidan mos rolni so'rang.",
    "role": "Rol",
    "superadmin": "Superadmin",
    "permissionCount": "{{count}} ta ruxsat"
  },
  "dashboard": {
    "title": "Statistika",
    "subtitle": "Tasdiqlangan uchrashuvlar — asosiy ko'rsatkich. Ro'yxatdan o'tganlar soni emas.",
    "period": "Davr",
    "confirmedMeetings": "Tasdiqlangan uchrashuvlar",
    "activeHosts": "Faol mezbonlar",
    "acceptRate": "Taklif → qabul",
    "confirmRate": "Qabul → tasdiq",
    "medianResponse": "Javob vaqti (median)",
    "repeatGuests": "Takroriy mehmonlar",
    "internalCirculation": "Ichki aylanma",
    "disputeRate": "Nizo darajasi",
    "revenue": "Platforma daromadi",
    "target": "Maqsad: {{value}}",
    "hours": "{{count}} soat",
    "funnelTitle": "Voronka",
    "funnelSignup": "Ro'yxatdan o'tdi",
    "funnelProfile": "Profil to'ldirdi",
    "funnelSearch": "Qidirdi",
    "funnelInvited": "Taklif yubordi",
    "funnelAccepted": "Qabul qilindi",
    "funnelConfirmed": "Tasdiqlandi",
    "meetingsChart": "Haftalik uchrashuvlar",
    "statusChart": "Takliflar holati bo'yicha",
    "empty": "Bu davr uchun ma'lumot yo'q",
    "rangeHint": "{{from}} — {{to}}. Solishtiriladi: {{comparedFrom}} — {{comparedTo}}.",
    "previousWas": "Oldingi davrda: {{value}}",
    "sectionCore": "Asosiy ko'rsatkichlar",
    "sectionUsers": "Foydalanuvchilar",
    "sectionMoney": "Qahva va pul",
    "invitationsSent": "Yuborilgan takliflar",
    "accepted": "Qabul qilingan",
    "ofHosts": "Jami {{value}} mezbondan",
    "newUsers": "Yangi foydalanuvchilar",
    "totalUsers": "Jami foydalanuvchilar",
    "activeUsers": "Davrda faol: {{value}}",
    "hosts": "Mezbonlar",
    "newHosts": "Davrda yangi: {{value}}",
    "blockedUsers": "Bloklangan",
    "deletedUsers": "O'chirilgan: {{value}}",
    "payments": "To'lovlar",
    "payouts": "Chiqarilgan pul",
    "paymentCount": "{{count}} ta to'lov · {{coffees}} sotildi",
    "pendingPayout": "Kutilmoqda: {{value}}",
    "liability": "Qaytarish zaxirasi",
    "liabilityHint": "Sarflanmagan qahva {{price}} narxida — eng yuqori chegara",
    "revenueHint": "Sotilgan qahvaning o‘zi — pul hech qayerga qaytmaydi",
    "coffeesPurchased": "Sotib olingan qahva",
    "coffeesWithdrawn": "Chiqarilgan qahva",
    "spentOnMeetings": "Uchrashuvlarga: {{value}}",
    "circulating": "Aylanmadagi qahva",
    "circulatingHint": "Bloklangan {{held}}, yetilmoqda {{maturing}}",
    "avgRating": "O'rtacha baho",
    "reviewCount": "{{count}} ta baho",
    "meetingsCount": "{{count}} uchrashuv",
    "minutes": "{{count}} daqiqa",
    "queueTitle": "Diqqat talab qiladi",
    "queueEmpty": "Navbat bo'sh — hozircha hech narsa kutmayapti.",
    "oldest": "eng eskisi {{value}}",
    "queue": {
      "negativeBalances": "Manfiy balansli foydalanuvchilar",
      "openDisputes": "Ochiq nizolar",
      "pendingWithdrawals": "To'lanmagan chiqarish so'rovlari",
      "stuckPayments": "Osilib qolgan to'lovlar",
      "expiringSoon": "Muddati tugayotgan takliflar",
      "pendingInvitations": "Javob kutayotgan takliflar",
      "blockedUsers": "Bloklangan foydalanuvchilar",
      "unverifiedHosts": "Tasdiqlanmagan mezbonlar"
    },
    "moneyChart": "Pul harakati",
    "topHosts": "Eng faol mezbonlar",
    "topGuests": "Eng faol mehmonlar",
    "topRated": "Reyting bo'yicha",
    "notEnoughRatings": "Hali yetarli baho yo'q",
    "providersTitle": "To'lov provayderlari",
    "formatsTitle": "Format va davomiylik",
    "regionsTitle": "Viloyatlar",
    "industriesTitle": "Sohalar",
    "providers": {
      "payme": "Payme",
      "click": "Click"
    },
    "formats": {
      "offline": "Jonli",
      "online": "Onlayn"
    },
    "withdrawalCount": "{{count}} ta chiqarish · {{coffees}} chiqarildi",
    "sectionQueueHint": "Kutib turgan ish. Har bir qator kerakli sahifaga olib boradi.",
    "sectionSummary": "Davr natijalari",
    "sectionSummaryHint": "Tanlangan davr va oldingi davr bilan solishtirma.",
    "sectionTrends": "Dinamika",
    "sectionTrendsHint": "Davr ichida raqamlar qanday o'zgargan.",
    "sectionFunnelHint": "Ro'yxatdan o'tishdan tasdiqlangan uchrashuvgacha: qayerda yo'qotyapmiz.",
    "sectionBreakdown": "Kesimlar",
    "sectionBreakdownHint": "Takliflar, to'lovlar va uchrashuvlar nima hisobiga to'planyapti.",
    "sectionTop": "Yetakchilar",
    "sectionTopHint": "Davrdagi eng faol mezbonlar va mehmonlar, reyting esa butun vaqt bo'yicha.",
    "noAccess": "Bu yerda ko'rsatadigan narsa yo'q",
    "noAccessHint": "Panel bloklarining birortasiga ham ruxsatingiz yo'q. Kerakli bo'limni administratordan so'rang."
  },
  "users": {
    "title": "Foydalanuvchilar",
    "subtitle": "Qidirish, bloklash va rol biriktirish.",
    "name": "Ism",
    "telegram": "Telegram",
    "phone": "Telefon",
    "status": "Holat",
    "balance": "Balans",
    "meetings": "Uchrashuvlar",
    "registered": "Ro'yxatdan o'tgan",
    "hostMode": "Mezbon",
    "verified": "Tasdiqlangan",
    "block": "Bloklash",
    "unblock": "Blokdan chiqarish",
    "blockTitle": "Foydalanuvchini bloklash",
    "blockReason": "Sabab",
    "blockHint": "Bloklangan foydalanuvchi kira olmaydi va takliflari bekor qilinadi. Bloklangan qahva mehmonga qaytadi.",
    "roles": "Rollar",
    "statuses": {
      "active": "Faol",
      "blocked": "Bloklangan",
      "deleted": "O'chirilgan"
    },
    "blockReasons": {
      "negative_balance": "Manfiy balans",
      "abuse": "Qoidabuzarlik",
      "fraud": "Firibgarlik",
      "admin_decision": "Administrator qarori"
    },
    "empty": "Foydalanuvchi topilmadi",
    "manageRoles": "Rollar",
    "lastSeen": "Oxirgi faollik",
    "loadFailed": "Ro'yxat yuklanmadi",
    "loadFailedHint": "Server javob bermadi. Sahifani yangilang yoki keyinroq urinib ko'ring.",
    "emptyHint": "Filtrni bo'shatib ko'ring — mos keluvchi foydalanuvchi topilmadi.",
    "superadmin": "Superadmin",
    "noRoles": "Rol biriktirilmagan",
    "profile": "Profil",
    "finance": "Moliya",
    "financeForbidden": "Pul ma'lumotlarini ko'rish uchun ruxsat yo'q (ledger.read).",
    "notFound": "Foydalanuvchi topilmadi",
    "availableBalance": "Mavjud qahva",
    "heldAndMaturing": "Bloklangan: {{held}} · Yetilmoqda: {{maturing}}",
    "coffeesBought": "Sotib olingan qahva",
    "withdrawn": "Chiqarilgan",
    "coffeesEarned": "Uchrashuvlardan",
    "coffeesSpent": "Uchrashuvlarga",
    "meetingsAsHost": "{{count}} ta uchrashuv mezbon sifatida",
    "meetingsAsGuest": "{{count}} ta uchrashuv mehmon sifatida",
    "net": "Sof harakat",
    "netHint": "Kirim (sotib olingan + ishlangan) minus chiqim (sarflangan + chiqarilgan).",
    "spentUzs": "{{amount}} so'm to'landi",
    "receivedUzs": "{{amount}} so'm tushdi",
    "asHost": "Mezbon sifatida",
    "asGuest": "Mehmon sifatida",
    "delete": "O'chirish",
    "deleted": "Akkaunt o'chirildi",
    "confirmDelete": "Akkaunt o'chirilgan deb belgilanadi va mezbon rejimi so'nadi. Yozuvlar bazadan o'chmaydi — hisob-kitob tarixi saqlanib qoladi. Bu amaldan qaytish yo'q: blokdan chiqarish o'chirilgan akkauntni tiklamaydi.",
    "expiresAt": "{{date}} gacha amal qiladi",
    "blockDuration": "Muddat",
    "blockForever": "Abadiy",
    "blockDays": "{{count}} kun",
    "blockUntil": "{{date}} gacha",
    "blockDurationHint": "Muddatli blok o‘z-o‘zidan yechiladi. Birinchi qoidabuzarlik uchun ko‘pincha bir hafta yetadi."
  },
  "invitations": {
    "title": "Takliflar",
    "subtitle": "Kimdan kimga, qachon yuborilgan, javob berilganmi va nega.",
    "guest": "Mehmon",
    "host": "Mezbon",
    "topic": "Mavzu",
    "coffees": "Qahva",
    "status": "Holat",
    "created": "Yaratilgan",
    "expires": "Muddati",
    "empty": "Taklif topilmadi",
    "statuses": {
      "pending": "Javob kutilmoqda",
      "accepted": "Qabul qilindi",
      "declined": "Rad etildi",
      "slot_taken": "Vaqt band bo'ldi",
      "expired": "Muddati tugadi",
      "cancelled_by_guest": "Mehmon bekor qildi",
      "cancelled_by_host": "Mezbon bekor qildi",
      "cancelled_by_admin": "Moderator bekor qildi",
      "confirmed": "Tasdiqlandi",
      "disputed": "Nizoda",
      "refunded": "Qaytarildi",
      "no_show": "Kelinmadi",
      "settled": "Taqsimlandi"
    },
    "refund": "Qo'lda qaytarish",
    "refundTitle": "Qahvani qaytarish",
    "refundHint": "Qahva mehmonga qaytariladi va ledger'ga yozuv tushadi. Bu amalni bekor qilib bo'lmaydi.",
    "refundAmount": "Qaytariladigan summa",
    "duration": "Davomiylik",
    "when": "Uchrashuv vaqti",
    "search": "Ism yoki Telegram",
    "sentAt": "Yuborilgan",
    "answeredAt": "Javob",
    "declineReason": "Sabab",
    "price": "Summa",
    "noAnswer": "Javob yo'q",
    "emptyHint": "Filtrni kengaytiring yoki boshqa sana oralig'ini tanlang.",
    "loadFailed": "Takliflar yuklanmadi",
    "loadFailedHint": "Server javob bermadi. Sahifani yangilab ko'ring.",
    "format": "Format",
    "formats": {
      "online": "Onlayn",
      "offline": "Jonli"
    },
    "detailTitle": "Uchrashuv kartochkasi",
    "detailSubtitle": "Taklifning o'zi, xona jurnali va ishtirok — bitta sahifada.",
    "notFound": "Taklif topilmadi",
    "notFoundHint": "Havola eskirgan yoki taklif o'chirilgan. Ro'yxatga qaytib qidiring.",
    "open": "Ochish",
    "sectionInvitation": "Taklif",
    "sectionRoom": "Onlayn xona",
    "roomOfflineHint": "Uchrashuv jonli bo'lgan: onlayn xona ochilmagan, shuning uchun jurnal ham yo'q.",
    "cancel": "Taklifni bekor qilish",
    "cancelHint": "Qahva mehmonga to‘liq qaytadi. Kech bekor qilish tovoni olinmaydi — mehmon hech narsa qilmagan.",
    "cancelConfirm": "Taklif yopiladi va qahva mehmonga to‘liq qaytariladi. Bu amalni ortga qaytarib bo‘lmaydi.",
    "cancelReason": "Sabab",
    "cancelReasonPlaceholder": "Masalan: mezbon bloklandi, uchrashuv o‘tmaydi",
    "cancelReasonHint": "Kamida 10 belgi. Audit jurnaliga va qahva yozuvining izohiga tushadi.",
    "cancelDone": "Taklif bekor qilindi",
    "cancelUnavailable": "Bu holatdagi taklif bekor qilinmaydi. Nizo shikoyat oynasidan hal qilinadi."
  },
  "ledger": {
    "title": "Hisob (ledger)",
    "subtitle": "Har bir qahva harakati o'zgarmas yozuv. Nizoni tekshirishning yagona yo'li.",
    "user": "Foydalanuvchi",
    "account": "Hisob",
    "amount": "Qahva",
    "refType": "Sabab",
    "refId": "Bog'liq yozuv",
    "createdAt": "Vaqt",
    "empty": "Yozuv topilmadi",
    "accounts": {
      "available": "Mavjud",
      "held": "Bloklangan",
      "maturing": "Yetilmoqda",
      "external": "Tashqi"
    },
    "balanceCheck": "Yig'indi tekshiruvi",
    "balanceCheckOk": "Barcha yozuvlar yig'indisi nolga teng",
    "balanceCheckFail": "Yozuvlar yig'indisi {{value}} — nolga teng emas. Bu tizimli xato.",
    "note": "Izoh",
    "inflow": "Kirim",
    "outflow": "Chiqim",
    "netFlow": "Sof",
    "external": "Tashqi",
    "externalHint": "Egasi yo'q hisob: pul tizimga kirgan yoki undan chiqqan joy.",
    "balanceOk": "Yig'indi nolga teng",
    "balanceBroken": "Yig'indi buzilgan",
    "adjustTitle": "Qahvani tuzatish",
    "adjustHint": "Yozuv o‘chirilmaydi — ustiga yangi yozuv qo‘yiladi. Sabab jurnalda qoladi.",
    "adjustDirection": "Yo‘nalish",
    "adjust_add": "Qo‘shish",
    "adjust_remove": "Olib qo‘yish",
    "adjustAmount": "Nechta qahva",
    "adjustAccount": "Qaysi hisob",
    "adjustPreview": "Balans:",
    "adjustNegative": "Balans manfiyga tushadi. To‘lov qaytarilgan holatda bu to‘g‘ri, boshqa holatda tekshiring.",
    "adjustNote": "Sabab",
    "adjustNotePlaceholder": "Masalan: Nizo #124 bo‘yicha qo‘lda qaytarish, bank hujjati 9912",
    "adjustNoteHint": "Kamida 10 belgi. Bir oy o‘tib «nega bunday qilingan?» degan savolga javob shu qatorda bo‘ladi.",
    "adjustSubmit": "Tuzatish",
    "adjustDone": "Hisob tuzatildi"
  },
  "payments": {
    "title": "To'lovlar",
    "subtitle": "Payme va Click orqali balansni to'ldirishlar.",
    "provider": "Provayder",
    "providerTxnId": "Provayder ID",
    "amount": "Summa, so'm",
    "coffees": "Qahva",
    "status": "Holat",
    "createdAt": "Vaqt",
    "empty": "To'lov topilmadi",
    "statuses": {
      "pending": "Kutilmoqda",
      "succeeded": "Muvaffaqiyatli",
      "cancelled": "Bekor qilindi",
      "failed": "Amalga oshmadi"
    },
    "paidAt": "To'langan vaqt",
    "succeededCount": "Muvaffaqiyatli",
    "totalAmount": "Summa"
  },
  "withdrawals": {
    "title": "Chiqarishlar",
    "subtitle": "Qahvani pulga chiqarish so'rovlari. Qahva so'rov paytida yechiladi.",
    "amount": "Summa, so'm",
    "destination": "Karta",
    "processedAt": "Hal bo'lgan vaqt",
    "createdAt": "Vaqt",
    "empty": "So'rov topilmadi",
    "statuses": {
      "pending": "Kutilmoqda",
      "paid": "To'landi",
      "rejected": "Rad etildi"
    },
    "coffees": "Qahva",
    "requestedAt": "So'ralgan vaqt",
    "note": "Izoh",
    "pendingCount": "Kutilmoqda",
    "paidAmount": "To'langan",
    "decide": "Qaror",
    "decideTitle": "Chiqarish bo'yicha qaror",
    "decideHint": "To'lovni bank orqali bajaring, keyin bu yerda belgilang. Rad etsangiz qahva mezbonga qaytadi.",
    "gross": "Jami",
    "tax": "Soliq ({{percent}}%)",
    "net": "Kartaga tushadi",
    "markPaid": "To'landi",
    "markedPaid": "Chiqarish to'langan deb belgilandi",
    "reject": "Rad etish",
    "rejected": "Chiqarish rad etildi, qahva qaytarildi",
    "notePlaceholder": "Bank hujjati raqami yoki rad etish sababi",
    "noteHint": "Rad etsangiz sabab majburiy va u foydalanuvchiga ko'rinadi.",
    "closedTitle": "Chiqarish yopiq (ADR 0025)",
    "closedBody": "Qahva pulga chiqarilmaydi: u faqat platformadan sotib olinadi va uchrashuvlarga sarflanadi. Yangi so'rov hosil bo'lmaydi va bu sahifa faqat qaror kutayotgan ESKI so'rovlar uchun qolgan. Ular hal bo'lgach, sahifa bo'shab qoladi."
  },
  "reports": {
    "title": "Shikoyatlar",
    "subtitle": "Asosli shikoyat qahvani mehmonga qaytaradi va profilga ta'sir qiladi. Ikkinchi asosli shikoyatdan keyin foydalanuvchi bloklanadi.",
    "reporter": "Shikoyatchi",
    "target": "Kim haqida",
    "reason": "Sabab",
    "comment": "Izoh",
    "status": "Holat",
    "createdAt": "Vaqt",
    "empty": "Shikoyat yo'q",
    "queueEmpty": "Navbat bo'sh — hozircha ko'rib chiqiladigan shikoyat yo'q.",
    "statuses": {
      "open": "Ochiq",
      "reviewing": "Ko'rilmoqda",
      "resolved": "Hal qilindi",
      "rejected": "Rad etildi"
    },
    "resolve": "Hal qilindi deb belgilash",
    "reject": "Asossiz deb belgilash",
    "blockTarget": "Profilni bloklash",
    "review": "Ko'rib chiqish",
    "meeting": "Uchrashuv",
    "meetingChat": "Yozishmalar",
    "threadReporter": "Shikoyatchi",
    "threadTarget": "Ikkinchi tomon",
    "threadEmpty": "Hali savol berilmagan.",
    "targetWarning": "Bu odam shikoyat borligini FAQAT siz yozganingizdan keyin biladi.",
    "moderator": "Moderatsiya",
    "party": "Foydalanuvchi",
    "ask": "Savol berish",
    "askPlaceholder": "Nima bo'lganini so'rang. Javob qarorga ta'sir qiladi.",
    "chatEmpty": "Bu uchrashuvda yozishma yo'q.",
    "alreadyResolved": "Qaror qabul qilingan — suhbat va tugmalar yopiq.",
    "confirmResolve": "Shikoyat asosli deb topilsinmi?",
    "confirmReject": "Shikoyat asossiz deb topilsinmi?",
    "moneyToGuest": "{{coffees}} qahva mehmonga qaytariladi. Bu shu odam ustidagi ikkinchi asosli shikoyat bo'lsa, u bloklanadi.",
    "moneyToHost": "Uchrashuv bo'lgan hisoblanadi: {{coffees}} qahva mezbonga o'tadi.",
    "noMoney": "Qaror hisobga tegmaydi — qahva allaqachon egasida. Faqat profilga ta'sir qiladi.",
    "notePlaceholder": "Nima aniqlandi? Izoh faqat moderatorlarga ko'rinadi.",
    "coffeeCount": "{{count}} qahva",
    "minuteCount": "{{count}} daqiqa",
    "formats": {
      "offline": "Jonli uchrashuv",
      "online": "Onlayn"
    },
    "reasons": {
      "no_show": "Kelmadi",
      "behavior": "Nomaqbul xatti-harakat",
      "spam": "Reklama yoki spam",
      "fake_profile": "Soxta profil",
      "other": "Boshqa sabab",
      "impersonation": "Boshqa shaxs nomidan"
    },
    "moneySplit": "Qahva taqsimlanadi: mezbonga {{host}}, mehmonga {{guest}}.",
    "splitLabel": "Mezbonga qancha qahva?",
    "splitPlaceholder": "Qaror bo'yicha hisoblansin",
    "splitHint": "Bo'sh qoldirsangiz: asosli shikoyatda hammasi mehmonga, asossizda hammasi mezbonga. Kechikish nizosida ulushni o'zingiz kiritasiz.",
    "splitInvalid": "0 dan {{coffees}} gacha son kiriting.",
    "roomLog": "Kirish jurnali",
    "roomLogEmpty": "LiveKit webhook'idan yozuv kelmagan. Bu \"hech kim kirmadi\" degani EMAS: yuqoridagi ishtirok jadvali serverning o'z yozuvidan olinadi va nizoda aynan u ishonchli manba.",
    "roomLogAfter": "boshlanishidan {{count}} daqiqa keyin",
    "roomLogBefore": "boshlanishidan {{count}} daqiqa oldin",
    "roomLogServer": "Server",
    "roomKinds": {
      "joined": "kirdi",
      "left": "chiqdi",
      "finished": "xona yopildi"
    },
    "notFound": "Shikoyat topilmadi",
    "notFoundHint": "Havola eskirgan bo'lishi mumkin. Navbatga qaytib, shikoyatni ro'yxatdan tanlang.",
    "decision": "Qaror",
    "decisionHint": "Qaror qaytarilmaydi: u profilga ta'sir qiladi va nizodagi uchrashuvda qahvani ko'chiradi.",
    "noteLabel": "Moderator izohi",
    "resolveForbidden": "Qaror qabul qilish huquqingiz yo'q — dalillarni faqat o'qiy olasiz.",
    "roomActivity": "Ishtirok",
    "roomActivityEmpty": "Ishtirok yozuvi yo'q.",
    "roomEntries": "{{count}} marta kirgan",
    "roomTotal": "Jami xonada: {{time}}",
    "roomOnline": "hozir xonada",
    "roomGuest": "Mehmon",
    "roomHost": "Mezbon",
    "roomSessionOpen": "yopilmagan",
    "roomActivityHint": "Kirish serverning o'z yozuvidan olinadi — LiveKit webhook'i yetib kelmagan bo'lsa ham ko'rinadi.",
    "roomLogTitle": "Tashqi jurnal (LiveKit)",
    "meetingCard": "Uchrashuv kartochkasi",
    "meetingEnds": "Tugash",
    "meetingConfirmed": "Tasdiqlangan",
    "selfPartyHint": "Siz bu shikoyatning tomonisiz — o'z nizongizni o'zingiz ko'rib chiqa olmaysiz. Uni boshqa moderator hal qilishi kerak.",
    "redact": "Xabarni to‘sish",
    "restore": "To‘sishni bekor qilish",
    "redacted": "Moderator to‘sgan",
    "redactHint": "Matn tomonlarga ko‘rinmay qoladi. Bu yerda esa to‘liq saqlanadi — xabar nizoda dalil.",
    "redactConfirm": "Xabarning matni tomonlarga ko‘rinmay qoladi. O‘chirilmaydi: siz uni shu yerda o‘qiy olasiz va istalgan payt qaytarasiz.",
    "restoreConfirm": "Matn tomonlarga qaytadi.",
    "redactReason": "Sabab",
    "redactReasonPlaceholder": "Masalan: haqorat va telefon raqami",
    "redactReasonHint": "Kamida 10 belgi. Audit jurnaliga tushadi.",
    "redactDone": "Xabar to‘sildi",
    "restoreDone": "To‘sish bekor qilindi"
  },
  "hostApplications": {
    "title": "Mezbon arizalari",
    "subtitle": "Mezbonlik tugma emas: har bir yangi mezbon shu navbatdan o'tadi.",
    "empty": "Ariza yo'q",
    "queueEmpty": "Navbat bo'sh — hozircha ko'rib chiqiladigan ariza yo'q.",
    "review": "Ko'rib chiqish",
    "statuses": {
      "pending": "Navbatda",
      "approved": "Tasdiqlangan",
      "rejected": "Rad etilgan"
    },
    "banned": "Mezbonlik cheklangan",
    "bannedHint": "Bu odam mezbonlik huquqidan mahrum qilingan. Arizani tasdiqlash hech narsa bermaydi — avval cheklovni yechish kerak.",
    "meetingCount": "{{count}} uchrashuv",
    "about": "O'zi haqida",
    "links": "Havolalar",
    "reviewNote": "Admin izohi",
    "level": "Ishonch",
    "levels": {
      "1": "1 — tekshirilmagan",
      "2": "2 — arizasi tasdiqlangan",
      "3": "3 — shaxsi tasdiqlangan"
    },
    "meetings": "Uchrashuvlar",
    "phone": "Telefon",
    "registered": "Ro'yxatdan o'tgan: {{date}}",
    "verifiedTitle": "Shaxsi tasdiqlangan",
    "approve": "Tasdiqlash",
    "reject": "Rad etish",
    "confirmApprove": "Ariza tasdiqlansinmi?",
    "confirmReject": "Ariza rad etilsinmi?",
    "approveHint": "Odam mezbon rejimini yoqa oladi va ishonch darajasi 2 ga ko'tariladi. Rejim avtomatik yoqilmaydi — uni odamning o'zi yoqadi.",
    "rejectHint": "Ariza qaytariladi va odam yangisini yozishi mumkin. Izoh unga ko'rinadi.",
    "notePlaceholder": "Sabab. Ariza beruvchi buni o'qiydi.",
    "alreadyReviewed": "Qaror qabul qilingan: {{date}}",
    "verify": "Yulduzcha berish",
    "unverify": "Yulduzchani olib qo'yish",
    "verifyHint": "Yulduzcha — platformaning “bu odam haqiqatan o'sha” degan kafolati. Arizadagi hikoyani uydirish mumkin; shikoyatsiz o'tgan uchrashuvni esa mehmonlar tekshirgan bo'ladi.",
    "verifyTooEarly": "Hali erta: tavsiya — kamida {{count}} ta tasdiqlangan uchrashuv. Qaror sizniki.",
    "confirmVerify": "Profilda tasdiq belgisi paydo bo'ladi va odamga xabar boradi.",
    "confirmUnverify": "Belgi olib tashlanadi. Shubha tug'ilganda bu blokdan ko'ra yumshoqroq chora.",
    "ban": "Mezbonlikdan chetlatish",
    "unban": "Cheklovni yechish",
    "banHint": "Bu akkaunt bloki EMAS va qahvalar musodara qilinmaydi: odam mehmon bo'lib qolaveradi va qahvasini ishlatadi, faqat katalogga qayta chiqa olmaydi.",
    "confirmBan": "Mezbon rejimi o'chadi va qayta yoqilmaydi. Qahvalarga va akkaunt holatiga tegilmaydi.",
    "confirmUnban": "Odam qayta mezbon bo'la oladi. Mezbon rejimi avtomatik yoqilmaydi — uni o'zi yoqadi.",
    "banNotePlaceholder": "Sabab. Foydalanuvchi buni o'qiydi.",
    "applicant": "Ariza beruvchi",
    "status": "Holat",
    "hostBan": "Cheklov",
    "submitted": "Yuborilgan",
    "notFound": "Ariza topilmadi",
    "notFoundHint": "Havola eskirgan yoki ariza o'chirilgan. Ro'yxatga qaytib, navbatdan qidiring.",
    "applicationSection": "Ariza",
    "decisionSection": "Qaror",
    "tier": "Toifa",
    "tiers": {
      "community": "Hamjamiyat",
      "partner": "Hamkor"
    },
    "tierHint": "Hamkor — platforma o‘zi taklif qilgan mezbon. Bu yorliq, to‘lov emas: qahva hech kimga pulga chiqarilmaydi va bu maydonga hech qanday to‘lov mantig‘i bog‘lanmagan.",
    "tierToPartner": "Hamkor qilish",
    "tierToCommunity": "Hamjamiyatga qaytarish",
    "confirmTierPartner": "Profilda «hamkor» yorlig‘i ko‘rinadi. Balansga va qahvaga hech qanday ta’siri yo‘q.",
    "confirmTierCommunity": "Yorliq olib tashlanadi. Balansga va qahvaga hech qanday ta’siri yo‘q."
  },
  "settings": {
    "title": "Platforma sozlamalari",
    "subtitle": "Narx, muddatlar va chegaralar bazada turadi — o'zgartirish uchun deploy kerak emas.",
    "dangerHint": "Bu qiymatlar butun mahsulotga darhol ta'sir qiladi. Narx va komissiya o'zgarishi allaqachon yuborilgan takliflarga tegmaydi: har bir taklif o'z summasi va bekor qilish shartlarini yuborilgan paytda muzlatib oladi.",
    "readOnlyHint": "Sizda faqat ko'rish ruxsati bor. O'zgartirish uchun `settings.update` kerak.",
    "loadFailed": "Sozlamalar yuklanmadi",
    "loadFailedHint": "Server javob bermadi. Qayta urinib ko'ring — muammo takrorlansa, backend loglarini tekshiring.",
    "retry": "Qayta urinish",
    "groupMoney": "Pul",
    "groupDeadlines": "Muddatlar",
    "groupCancel": "Bekor qilish",
    "groupSchedule": "Jadval",
    "invitationTtl": "Taklifga javob muddati",
    "invitationTtlHint": "Shu vaqtda javob bo'lmasa, taklif bekor bo'ladi va qahva mehmonga qaytadi.",
    "payoutMaturity": "To'lov yetilish muddati",
    "payoutMaturityHint": "Uchrashuv qahvasi shu muddat o'tgach pulga chiqarishga ochiladi. Shu oyna ichida shikoyat kelsa, moderator qahvani taqsimlashi mumkin. Shikoyat oynasidan uzun bo'lmasligi kerak.",
    "freeCancel": "Bepul bekor qilish oynasi",
    "freeCancelHint": "Uchrashuvgacha shundan ko'p vaqt qolgan bo'lsa, mehmon jarimasiz bekor qiladi.",
    "lateRefund": "Kech bekor qilishda qaytadigan ulush",
    "lateRefundHint": "Oyna o'tib ketgan bo'lsa shuncha qismi mehmonga qaytadi, qolgani mezbonda tovon bo'lib qoladi.",
    "bookingHorizon": "Jadval gorizonti",
    "bookingHorizonHint": "Katalogda shundan uzoqdagi slotlar ko'rsatilmaydi.",
    "minNotice": "Eng yaqin band qilish",
    "minNoticeHint": "Slotni kamida shuncha vaqt oldin band qilish mumkin.",
    "range": "{{min}}–{{max}}",
    "percent": "%",
    "hours": "soat",
    "days": "kun",
    "errInteger": "Butun son kiriting",
    "errRange": "{{min}}–{{max}} oralig'ida bo'lishi kerak",
    "confirmTitle": "Pulga tegadigan o'zgarish",
    "confirmBody": "Narx va komissiya butun platformaga darhol ta'sir qiladi. Yuborilgan takliflar eski qiymatlari bilan qoladi.",
    "confirmLabel": "Saqlash",
    "saved": "Sozlamalar saqlandi",
    "buyPrice": "Sotib olish narxi",
    "buyPriceHint": "1 qahvani sotib olish narxi. Foydalanuvchi kartasidan shu summa yechiladi.",
    "sellPrice": "Chiqarish narxi",
    "sellPriceHint": "1 qahvani chiqarish narxi. Mezbon kartasiga shu summa tushadi. Ikki narxning farqi — platforma daromadi.",
    "errSellAboveBuy": "Chiqarish narxi sotib olish narxidan baland bo'lmasligi kerak.",
    "groupChat": "Chat va moderatsiya",
    "reminderHours": "Eslatma",
    "reminderHoursHint": "Uchrashuvdan necha soat oldin eslatma yuboriladi.",
    "chatOpens": "Chat ochilishi",
    "chatOpensHint": "Uchrashuvdan necha soat oldin chat ochiladi. Tomonlar bir-birining raqamini ko'rmaydi — chat ularning yagona aloqa kanali.",
    "chatCloses": "Chat yopilishi",
    "chatClosesHint": "Uchrashuv tugagandan necha soat keyin chat yopiladi. Yozishmalar saqlanib qoladi.",
    "reportWindow": "Shikoyat oynasi",
    "reportWindowHint": "Uchrashuvdan keyin shikoyat yozish uchun necha soat beriladi.",
    "errReportBeforePayout": "Shikoyat oynasi to'lov yetilish muddatidan qisqa bo'lolmaydi: qahva muzlagan, lekin shikoyat yozib bo'lmaydigan oraliq paydo bo'ladi.",
    "errStep": "Qiymat {{step}} ning karralisi bo'lishi kerak",
    "rangeStep": "{{min}}–{{max}}, {{step}} qadam bilan"
  },
  "meetingOptions": {
    "title": "Uchrashuv variantlari",
    "subtitle": "Qaysi formatlar va davomiyliklar taklif qilinishini shu yerdan boshqarasiz.",
    "dangerHint": "O'zgarish DARHOL kuchga kiradi. O'chirilgan variant ommaviy sahifada ko'rinib turadi, lekin tanlab bo'lmaydi; mezbon ham uni profilida yoqa olmaydi; kutib turgan taklifni mezbon QABUL QILA OLMAYDI — rad etsa yoki muddati o'tsa, qahva mehmonga qaytadi. Allaqachon kelishilgan uchrashuvlar esa o'z vaqtida o'tadi: kelishuv va pul ularda bog'langan.",
    "loadFailed": "Variantlar yuklanmadi",
    "loadFailedHint": "Server javob bermadi. Qayta urinib ko'ring — muammo takrorlansa, backend loglarini tekshiring.",
    "formats": "Formatlar",
    "durations": "Davomiyliklar",
    "format": {
      "offline": "Oflayn",
      "online": "Onlayn"
    },
    "formatHint": {
      "offline": "Yuzma-yuz uchrashuv. Manzil chatda kelishiladi.",
      "online": "Video orqali uchrashuv."
    },
    "disabled": "O'chirilgan",
    "lastEnabled": "Oxirgi yoqilgan variant — uni o'chirib bo'lmaydi.",
    "note": "O'chirilish sababi",
    "noteHint": "Ommaviy sahifada shu matn chiqadi. Bo'sh qoldirsangiz standart matn ko'rsatiladi: “Bu taklif hozircha tanlab bo'lmaydi”.",
    "notePlaceholder": "Masalan: onlayn uchrashuvlar 1-oktabrgacha to'xtatilgan",
    "saveNote": "Saqlash",
    "saved": "O'zgarish saqlandi",
    "add": "Qo'shish",
    "added": "Davomiylik qo'shildi",
    "addTitle": "Yangi davomiylik",
    "addHint": "Davomiylik keyin o'zgartirilmaydi: unga tariflar va takliflar bog'lanadi. Xato kiritilsa, uni o'chirib qo'yasiz.",
    "minutesLabel": "Davomiylik, daqiqa",
    "minutesHint": "{{min}} dan {{max}} gacha.",
    "toggleDuration": "{{minutes}} daqiqalik uchrashuv",
    "minutes": "{{count}} daq",
    "hours": "{{count}} soat",
    "remove": "O'chirish",
    "removed": "Davomiylik o'chirildi",
    "removeTitle": "Davomiylikni ro'yxatdan olib tashlash",
    "removeHint": "Bu faqat hech qayerda ishlatilmagan davomiylik uchun ishlaydi. Tarifi yoki taklifi bori o'chirilmaydi — uni o'chirib qo'ying.",
    "err": {
      "integer": "Butun son kiriting.",
      "range": "Qiymat chegaradan tashqarida.",
      "duplicate": "Bunday davomiylik allaqachon bor.",
      "coffeeRange": "{{min}} dan {{max}} gacha son kiriting."
    },
    "limitsTitle": "Taklif chegaralari",
    "limitsHint": "Har bir format uchun alohida: offlayn uchrashuvda mezbonning yo'li va joyi bor. Bu — PASTKI chegara, mezbon undan yuqori narx qo'yishi mumkin. Onlayn formatda uzunroq uchrashuv daqiqasiga arzonlashmasligi kerak: 30 daqiqalik minimum 15 daqiqalikdan kamida ikki barobar bo'ladi.",
    "minCoffeesLabel": "Eng kam qahva",
    "coffees": "qahva",
    "coffeesFrom": "qahvadan boshlab",
    "limitAria": "{{duration}}, {{format}}: {{field}}",
    "limitAriaNew": "{{format}}: {{field}}"
  },
  "table": {
    "rowsPerPage": "Sahifada",
    "of": "/",
    "page": "Sahifa",
    "first": "Birinchi",
    "previous": "Oldingi",
    "next": "Keyingi",
    "last": "Oxirgi",
    "noResults": "Natija yo'q",
    "columns": "Ustunlar",
    "total": "Jami: {{count}}",
    "sort": "Saralash",
    "sortAsc": "O'sish bo'yicha",
    "sortDesc": "Kamayish bo'yicha",
    "onThisPage": "Shu sahifada",
    "clearFilters": "Filtrlarni tozalash",
    "records": "{{count}} yozuv",
    "loadFailed": "Ro'yxat yuklanmadi",
    "loadFailedHint": "Server javob bermadi. Sahifani yangilang yoki keyinroq urinib ko'ring.",
    "emptyFiltered": "Filtrni bo'shatib ko'ring — mos keluvchi yozuv topilmadi."
  },
  "errors": {
    "BELOW_HOST_MINIMUM": "Mezbonning minimal tarifidan kam.",
    "BROADCAST_NOT_LIVE": "Efir hozir ketmayapti.",
    "BROADCAST_NOT_READY": "Efirni boshlab bo'lmadi: tomosha havolasi qo'yilmagan yoki efir e'lon qilinmagan.",
    "CANCELLATION_WINDOW_CLOSED": "Uchrashuv boshlangan — bekor qilib bo'lmaydi.",
    "CHAT_CLOSED": "Chat yopilgan.",
    "CHAT_NOT_AVAILABLE": "Bu taklif uchun chat yo'q.",
    "CONFIRMATION_ALREADY_USED": "Bu kod allaqachon ishlatilgan.",
    "CONFIRMATION_CODE_EXPIRED": "Tasdiqlash kodi muddati tugagan.",
    "CONFIRMATION_CODE_INVALID": "Tasdiqlash kodi noto'g'ri.",
    "CONFIRMATION_LOCKED": "Xato urinishlar chegarasi oshdi — kod terish vaqtincha yopilgan.",
    "CONFIRMATION_NOT_APPLICABLE": "Onlayn uchrashuv kod bilan tasdiqlanmaydi — uni tizim kirish jurnali bo'yicha o'zi yakunlaydi.",
    "CONFIRMATION_TOO_EARLY": "Uchrashuv hali boshlanmagan.",
    "DISPUTE_CLOSED": "Nizo suhbati yopilgan.",
    "DISPUTE_SELF_PARTY": "Siz bu shikoyatning tomonisiz: o'z nizongizni o'zingiz ko'rib chiqa olmaysiz.",
    "DUPLICATE_TRANSACTION": "Bu tranzaksiya allaqachon qayd etilgan.",
    "DURATION_DISABLED": "Bu davomiylik hozircha o'chirilgan.",
    "DURATION_NOT_OFFERED": "Mezbon bu davomiylikdagi uchrashuvlarni taklif qilmaydi.",
    "FORBIDDEN": "Bu amal uchun ruxsat yo'q.",
    "FORMAT_DISABLED": "Bu format hozircha o'chirilgan.",
    "FORMAT_NOT_OFFERED": "Mezbon bu formatni taklif qilmaydi.",
    "HOST_APPLICATION_ALREADY_REVIEWED": "Ariza allaqachon ko'rib chiqilgan — sahifani yangilang.",
    "HOST_APPLICATION_EXISTS": "Bu foydalanuvchida ko'rib chiqilayotgan ariza bor.",
    "HOST_APPLICATION_NOT_FOUND": "Ariza topilmadi.",
    "HOST_APPLICATION_REQUIRED": "Avval ariza kerak.",
    "HOST_BANNED": "Bu foydalanuvchi uchun mezbonlik cheklangan.",
    "HOST_UNAVAILABLE": "Mezbon taklif qabul qilmayapti.",
    "INSUFFICIENT_BALANCE": "Balans yetmaydi: kerak {{required}} qahva, mavjud {{available}} qahva.",
    "INTERNAL_ERROR": "Serverda xatolik. Tez orada tuzatiladi.",
    "INVALID_STATE_TRANSITION": "Bu amalni hozirgi holatda bajarib bo'lmaydi. Sahifani yangilang.",
    "INVITATION_ALREADY_SENT": "Bu vaqtga taklif allaqachon yuborilgan.",
    "INVITATION_NOT_FOUND": "Taklif topilmadi.",
    "INVITE_CODE_REQUIRED": "Yopiq beta: taklif yuborish uchun taklif kodi kerak.",
    "LEDGER_IMBALANCE": "Hisobda nomuvofiqlik. Bu tizimli xato — darhol tekshiring.",
    "NETWORK_ERROR": "Serverga ulanib bo'lmadi. Internet aloqasini tekshiring.",
    "NOT_A_SPEAKER": "Bu odam efirning spikeri emas.",
    "NOT_FOUND": "So'ralgan ma'lumot topilmadi.",
    "NO_AVAILABILITY_CONFIGURED": "Mezbon jadval belgilamagan.",
    "PAYLOAD_TOO_LARGE": "Fayl juda katta.",
    "PAYMENT_FAILED": "To'lov amalga oshmadi.",
    "PAYMENT_PROVIDER_DISABLED": "To'lov tizimi vaqtincha ulanmagan. Birozdan keyin urinib ko'ring.",
    "PAYOUT_PROFILE_LOCKED": "Tasdiqlangan profil o'zgartirilmaydi.",
    "PAYOUT_PROFILE_REQUIRED": "Chiqarish uchun tasdiqlangan soliq profili kerak.",
    "PROFILE_INCOMPLETE": "Profil to'liq emas.",
    "PROMO_BUDGET_EXHAUSTED": "Bonus byudjeti shu oyga tugadi. Sozlamalardan oshirish mumkin.",
    "PROMO_CODE_NOT_FOUND": "Bunday promo kod topilmadi.",
    "PROMO_CODE_UNAVAILABLE": "Kod hozir ishlamaydi: o'chirilgan, muddati o'tgan yoki tugagan.",
    "RATE_LIMITED": "Juda ko'p so'rov yuborildi. Bir oz kutib turing.",
    "REPORT_ALREADY_EXISTS": "Bu uchrashuv bo'yicha shikoyat bor.",
    "REPORT_ALREADY_RESOLVED": "Shikoyat allaqachon yopilgan — sahifani yangilang.",
    "REPORT_NOT_ALLOWED": "Bu uchrashuvga shikoyat qoldirib bo'lmaydi.",
    "REPORT_NOT_FOUND": "Shikoyat topilmadi.",
    "REVIEW_ALREADY_EXISTS": "Baho allaqachon qoldirilgan.",
    "REVIEW_NOT_ALLOWED": "Bu uchrashuvga baho qoldirib bo'lmaydi.",
    "ROOM_CLOSED": "Xona yopilgan.",
    "ROOM_NOT_AVAILABLE": "Bu uchrashuvda onlayn xona yo'q.",
    "ROOM_PARTICIPANT_PRESENT": "Suhbatdosh allaqachon xonada.",
    "ROOM_SERVER_UNAVAILABLE": "Video serveri hozir javob bermayapti.",
    "SELF_INVITATION": "O'ziga taklif yuborib bo'lmaydi.",
    "SESSION_REVOKED": "Sessiya yopilgan. Qaytadan kiring.",
    "SLOT_ALREADY_TAKEN": "Bu vaqt allaqachon band.",
    "SLOT_NOT_AVAILABLE": "Bu vaqt mezbon jadvalida yo'q.",
    "SPEAKER_NOT_HOST": "Spiker faol mezbon bo'lishi kerak.",
    "TELEGRAM_PHOTO_NOT_FOUND": "Telegram'da profil rasmi topilmadi.",
    "TOKEN_EXPIRED": "Sessiya muddati tugadi. Qaytadan kiring.",
    "TOKEN_INVALID": "Sessiya yaroqsiz. Qaytadan kiring.",
    "UNAUTHORIZED": "Kirish talab qilinadi.",
    "UNKNOWN": "Kutilmagan xatolik yuz berdi. Qaytadan urinib ko'ring.",
    "USER_BLOCKED": "Foydalanuvchi bloklangan.",
    "USER_NOT_FOUND": "Foydalanuvchi topilmadi.",
    "VALIDATION_FAILED": "Ma'lumotlar to'g'ri emas. Formani tekshiring.",
    "WITHDRAWALS_DISABLED": "Qahva pulga chiqarilmaydi. U faqat uchrashuvlarga sarflanadi.",
    "WITHDRAWAL_BELOW_MINIMUM": "Chiqarish eng kam summadan past.",
    "WITHDRAWAL_NOT_PENDING": "Bu chiqarish allaqachon ko'rib chiqilgan."
  },
  "notFound": {
    "title": "Sahifa topilmadi",
    "body": "Havola eskirgan yoki manzil noto'g'ri yozilgan.",
    "cta": "Boshqaruv paneliga"
  },
  "errorPage": {
    "title": "Nimadir noto'g'ri ketdi",
    "body": "Xatolik qayd etildi. Sahifani yangilab ko'ring.",
    "retry": "Qayta urinish",
    "staleTitle": "Panel yangilandi",
    "staleBody": "Siz panelning eski nusxasini ko‘rib turgansiz. Sahifani qayta yuklang — ochiq turgan ish yo‘qolmaydi.",
    "staleRetry": "Sahifani qayta yuklash"
  },
  "roles": {
    "title": "Rollar va ruxsatlar",
    "subtitle": "Rol — ruxsatlar to'plamiga qo'yilgan nom. Istalgancha rol yaratsangiz bo'ladi: kod rol nomini bilmaydi, har bir amal ruxsat bo'yicha tekshiriladi.",
    "create": "Rol yaratish",
    "createTitle": "Yangi rol",
    "editTitle": "Rolni tahrirlash",
    "formHint": "Ruxsatlarni bo'lim bo'yicha yoki bittalab belgilang. Ro'yxat backenddan keladi va faqat o'qiladi.",
    "code": "Kod",
    "codeHint": "Kichik harf, raqam va _. Yaratilgandan keyin o'zgarmaydi.",
    "name": "Nomi",
    "description": "Izoh",
    "permissions": "Ruxsatlar",
    "selectedCount": "{{count}} ta tanlandi",
    "permissionCount": "{{count}} ta ruxsat",
    "system": "Tizim roli",
    "empty": "Hali rol yaratilmagan",
    "emptyHint": "Birinchi rolni yarating va uni foydalanuvchilarga biriktiring. Superadmin rolsiz ham hamma narsaga kira oladi.",
    "deleted": "Rol o'chirildi",
    "deleteTitle": "Rolni o'chirasizmi?",
    "deleteHint": "«{{name}}» roli o'chiriladi va u biriktirilgan barcha foydalanuvchilardan olib tashlanadi. Ular shu rol bergan huquqlarini darhol yo'qotadi.",
    "assigned": "Rollar saqlandi",
    "assignTitle": "Rollarni biriktirish",
    "assignHint": "{{name}} uchun rollarni tanlang. Ruxsatlar tanlangan rollarning birlashmasi bo'ladi.",
    "groups": {
      "dashboard": "Boshqaruv paneli",
      "users": "Foydalanuvchilar",
      "roles": "Rollar",
      "hosts": "Mezbonlar",
      "invitations": "Takliflar",
      "ledger": "Hisob (ledger)",
      "payments": "To'lovlar",
      "reports": "Shikoyatlar",
      "reference": "Ma'lumotnomalar",
      "settings": "Sozlamalar",
      "audit": "Audit jurnali",
      "analytics": "Analitika",
      "sidebar": "Yon menyu"
    },
    "created": "Rol yaratildi",
    "updated": "Rol saqlandi",
    "notFound": "Rol topilmadi",
    "notFoundHint": "Havola eskirgan yoki rol o'chirilgan. Ro'yxatga qayting va uni qaytadan tanlang.",
    "readOnly": "Faqat ko'rish: bu rolni o'zgartirish huquqingiz yo'q.",
    "selectGroup": "«{{group}}» bo'limining hamma ruxsatlari",
    "groupSelected": "{{selected}}/{{total}}",
    "expandAll": "Hammasini ochish",
    "collapseAll": "Hammasini yig'ish",
    "errors": {
      "nameMin": "Nom kamida 2 ta belgidan iborat bo'lsin",
      "codeFormat": "Kichik harfdan boshlanadi; harf, raqam va _ dan iborat"
    }
  },
  "analytics": {
    "title": "Analitika",
    "subtitle": "Tashriflar, sahifalar va voronka — o'z ma'lumotlarimizdan. Yandex Metrika alohida panelda: u \"qayerdan keldi\" ni ko'rsatadi, bu sahifa esa \"nima qildi\" ni.",
    "views": "Sahifa ochilishlari",
    "visitors": "Noyob tashrifchilar",
    "identified": "Kirgan foydalanuvchilar",
    "traffic": "Kunlik trafik",
    "topPages": "Eng ko'p ochilgan sahifalar",
    "topReferrers": "Trafik manbalari",
    "events": "Hodisalar",
    "empty": "Bu davrda ma'lumot yo'q",
    "emptyHint": "Hodisalar sayt ochilganda yig'ila boshlaydi. Frontendda NEXT_PUBLIC_ANALYTICS_URL to'ldirilganini tekshiring.",
    "noReferrers": "Manbasiz tashriflar: odam manzilni o'zi yozgan yoki havolani xabar orqali olgan."
  },
  "reference": {
    "title": "Ma'lumotnomalar",
    "subtitle": "Soha, viloyat va tuman ro'yxatlari. Bu yerdagi o'zgarish saytdagi barcha formalar va filtrlarga darhol tegadi.",
    "create": {
      "industries": "Soha qo'shish",
      "regions": "Viloyat qo'shish",
      "districts": "Tuman qo'shish"
    },
    "editTitle": "Yozuvni tahrirlash",
    "formHint": "Nom uchala tilda to'ldirilishi kerak — aks holda o'sha tilda kodning o'zi ko'rinadi.",
    "code": "Kod",
    "codeHint": "Faqat kichik lotin harflari, raqam va defis. Yaratilgandan keyin o'zgarmaydi.",
    "name": {
      "uz": "Nomi (uz)",
      "ru": "Nomi (ru)",
      "en": "Nomi (en)"
    },
    "sortOrder": "Tartib",
    "status": "Holat",
    "active": "Faol",
    "inactive": "O'chirilgan",
    "region": "Viloyat",
    "regionHint": "Yaratilgandan keyin viloyat o'zgarmaydi.",
    "type": "Turi",
    "typeDistrict": "Tuman",
    "typeCity": "Shahar",
    "count": "{{count}} ta yozuv",
    "empty": "Ro'yxat bo'sh",
    "emptyHint": "Birinchi yozuvni qo'shing.",
    "saved": "Saqlandi",
    "titles": {
      "industries": "Sohalar",
      "regions": "Viloyatlar",
      "districts": "Tumanlar"
    },
    "subtitles": {
      "industries": "Profil formasidagi soha ro'yxati. O'zgarish saytdagi barcha formalar va filtrlarga darhol tegadi.",
      "regions": "Viloyatlar ro'yxati. Tumanlar shu ro'yxatga bog'lanadi.",
      "districts": "Tuman va tuman huquqidagi shaharlar. Har biri bitta viloyatga tegishli."
    },
    "allRegions": "Barcha viloyatlar",
    "loadFailed": "Ro'yxat yuklanmadi",
    "loadFailedHint": "Server javob bermadi. Sahifani yangilang yoki keyinroq urinib ko'ring."
  },
  "activity": {
    "title": "Faoliyat",
    "time": "Vaqt",
    "action": "Amal",
    "actor": "Kim",
    "changes": "O'zgarishlar",
    "ip": "IP",
    "self": "O'zi",
    "system": "Tizim",
    "more": "yana {{count}} ta",
    "empty": "Hozircha faoliyat yozuvi yo'q"
  },
  "devices": {
    "title": "Qurilmalar",
    "device": "Qurilma",
    "startedAt": "Kirgan vaqti",
    "lastUsed": "Oxirgi faollik",
    "revoke": "Chiqarish",
    "revoked": "Seans bekor qilindi",
    "unknown": "Noma'lum qurilma",
    "empty": "Faol seans yo'q"
  },
  "audit": {
    "title": "Audit jurnali",
    "subtitle": "Kim, qachon va nima qilgan — butun platforma bo'yicha.",
    "empty": "Yozuv topilmadi",
    "entity": "Obyekt",
    "from": "Sanadan",
    "to": "Sanagacha",
    "actorRole": "Roli",
    "requestId": "So'rov ID",
    "userAgent": "Qurilma",
    "before": "Oldin",
    "after": "Keyin",
    "noPayload": "Ma'lumot yozilmagan"
  },
  "adminNotifications": {
    "title": "Navbat",
    "empty": "Yangi xabar yo'q. Bu yerda navbatga tushgan ish paydo bo'ladi: ariza, shikoyat va pul harakati.",
    "unread": "{{count}} ta yangi",
    "markRead": "O'qilgan deb belgilash",
    "clear": "Tozalash",
    "sessionOnly": "Ro'yxat faqat shu tab uchun: sahifa yangilanganda tozalanadi, navbatning o'zi esa o'z sahifasida qoladi.",
    "types": {
      "host_application_submitted": "Yangi mezbon arizasi",
      "report_submitted": "Yangi shikoyat",
      "withdrawal_created": "Pul chiqarish so'rovi",
      "payment_succeeded": "Yangi to'lov"
    }
  },
  "promo": {
    "title": "Promo kodlar",
    "subtitle": "Bonus qahva, taklif kodlari va kampaniyalar. Bonus qahvani mezbon chiqarganda platforma pul to'laydi — bu marketing xarajati.",
    "create": "Yangi kod",
    "createTitle": "Yangi promo kod",
    "createHint": "Kod bosh harfga keltirib saqlanadi. Odam uni qanday yozishi muhim emas.",
    "editTitle": "Kodni o'zgartirish",
    "editHint": "Kodning o'zi va qahva soni o'zgarmaydi — ular allaqachon tarqatilgan va'da. Kampaniyani to'xtatish yoki muddatini uzaytirish mumkin.",
    "edit": "O'zgartirish",
    "saved": "Saqlandi",
    "created": "Kod yaratildi",
    "empty": "Hali kod yo'q",
    "emptyHint": "Birinchi kodni yaratib, uni mezbonlar orqali tarqating.",
    "loadFailed": "Ro'yxat yuklanmadi",
    "loadFailedHint": "Sahifani yangilab ko'ring.",
    "coffees": "{{count}} qahva",
    "noCoffees": "Qahvasiz",
    "noDeadline": "Muddatsiz",
    "usedUnlimited": "{{used}} marta",
    "columns": {
      "code": "Kod",
      "coffees": "Beradi",
      "uses": "Ishlatilgan",
      "endsAt": "Tugaydi",
      "state": "Holat"
    },
    "kind": {
      "invite": "Taklif"
    },
    "state": {
      "active": "Ishlaydi",
      "disabled": "O'chirilgan",
      "exhausted": "Tugagan",
      "expired": "Muddati o'tgan"
    },
    "fields": {
      "code": "Kod",
      "coffees": "Nechta qahva beradi",
      "coffeesHint": "0 — qahva bermaydi. Taklif kodi uchun bu normal: u faqat huquq ochadi.",
      "invite": "Taklif kodi",
      "inviteHint": "Yopiq beta davrida taklif yuborish huquqini ochadi.",
      "maxUses": "Jami necha marta",
      "maxUsesPlaceholder": "Bo'sh — cheksiz",
      "endsAt": "Qachongacha",
      "note": "Izoh",
      "notePlaceholder": "Qaysi kampaniya, kim so'radi",
      "enabled": "Ishlayapti",
      "enabledHint": "O'chirsangiz kod darhol qabul qilinmaydi. Berilgan bonuslar joyida qoladi."
    }
  },
  "live": {
    "title": "Efirlar",
    "subtitle": "Qahvadosh Live: efirni YouTube uzatadi, savol-javob esa saytda qoladi.",
    "create": "Yangi efir",
    "createTitle": "Yangi efir",
    "editTitle": "Efirni tahrirlash",
    "formHint": "Efir QORALAMA sifatida saqlanadi — e'lon qilinmaguncha uni hech kim ko'rmaydi.",
    "empty": "Hali efir yaratilmagan.",
    "loadFailed": "Efirlar ro'yxati yuklanmadi.",
    "fieldTitle": "Sarlavha",
    "fieldDescription": "Tavsif",
    "fieldScheduledAt": "Vaqti",
    "fieldSlug": "Havola",
    "slugPlaceholder": "sarlavhadan yasaladi",
    "slugHint": "Bo'sh qoldirsangiz sarlavhadan yasaladi. Band bo'lsa raqam qo'shiladi.",
    "slugLocked": "E'lon qilingan efir havolasi o'zgarmaydi — u tarqalgan bo'lishi mumkin.",
    "fieldWatchUrl": "Tomosha havolasi",
    "watchUrlHint": "YouTube havolasi. Efirni boshlash uchun SHART — usiz sahifada pleyer bo'lmaydi.",
    "fieldSpeakers": "Spikerlar",
    "addSpeaker": "Spiker qo'shish",
    "removeSpeaker": "Spikerni olib tashlash",
    "rolePlaceholder": "Roli",
    "noSpeakers": "Faol mezbon topilmadi. Spiker mezbon bo'lishi shart.",
    "publish": "E'lon qilish",
    "cancel": "Bekor qilish",
    "start": "Boshlash",
    "stop": "Tugatish",
    "startBlocked": "Boshlash uchun tomosha havolasi kerak.",
    "rtmpLabel": "RTMP manzillari",
    "rtmpPlaceholder": "rtmp://... (ixtiyoriy)",
    "started": "Efir boshlandi, xabarlar yuborildi",
    "stopped": "Efir tugatildi",
    "startFailed": "Efir boshlanmadi",
    "stopFailed": "Efir tugatilmadi",
    "statusChanged": "Holat o'zgartirildi",
    "statusFailed": "Holat o'zgartirilmadi",
    "created": "Efir yaratildi",
    "updated": "Efir saqlandi",
    "saveFailed": "Efir saqlanmadi",
    "reminderCount": "{{count}} eslatma",
    "questionCount": "{{count}} savol",
    "questionsTitle": "Savollar",
    "noQuestions": "Hali savol yo'q.",
    "markAnswered": "Javob berildi",
    "hide": "Yashirish",
    "unhide": "Qaytarish",
    "questionFailed": "Savol holati o'zgartirilmadi",
    "statusAnswered": "Javob berildi",
    "statusHidden": "Yashirilgan",
    "status": {
      "draft": "Qoralama",
      "scheduled": "E'lon qilingan",
      "live": "Jonli",
      "ended": "Tugagan",
      "canceled": "Bekor qilingan"
    }
  },
  "payouts": {
    "title": "Chiqarish profillari",
    "subtitle": "Mezbon pul chiqarishdan oldin kimligini va soliq maqomini tasdiqlaydi. Tasdiqlangan profil egasiga chiqarish ochiladi.",
    "tabs": {
      "pending": "Navbatda",
      "approved": "Tasdiqlangan",
      "rejected": "Rad etilgan"
    },
    "status": {
      "individual": "Jismoniy shaxs",
      "sole_trader": "YaTT",
      "legal_entity": "Yuridik shaxs"
    },
    "empty": {
      "pending": "Navbat bo'sh",
      "approved": "Tasdiqlangan profil yo'q",
      "rejected": "Rad etilgan profil yo'q"
    },
    "account": "Akkaunt: {{name}}",
    "pinfl": "PINFL •••• {{last4}}",
    "noPinfl": "PINFL kiritilmagan",
    "tin": "STIR {{tin}}",
    "review": "Ko'rib chiqish",
    "reviewTitle": "Profil bo'yicha qaror",
    "effect": {
      "individual": "{{name}} — jismoniy shaxs. Tasdiqlasangiz, chiqarish ochiladi va har to'lovdan daromad solig'i ushlab qolinadi.",
      "sole_trader": "{{name}} — YaTT. Tasdiqlasangiz, chiqarish ochiladi va unga TO'LIQ summa o'tkaziladi.",
      "legal_entity": "{{name}} — yuridik shaxs. Tasdiqlasangiz, chiqarish ochiladi va unga TO'LIQ summa o'tkaziladi."
    },
    "fields": {
      "account": "Akkaunt",
      "fullName": "To'liq ism",
      "pinfl": "PINFL",
      "tin": "STIR",
      "note": "Izoh"
    },
    "notePlaceholder": "Rad etsangiz sabab majburiy",
    "noteHint": "Rad etish sababi foydalanuvchiga ko'rinadi — nima tuzatishini yozing.",
    "approve": "Tasdiqlash",
    "reject": "Rad etish",
    "approved": "Profil tasdiqlandi",
    "rejected": "Profil rad etildi",
    "closedTitle": "Yangi profil qabul qilinmaydi (ADR 0025)",
    "closedBody": "Chiqarish yopilgani uchun soliq profilining ham vazifasi qolmadi: yangi profil yuborib bo'lmaydi. Mavjud yozuvlar moderator tarixi sifatida qoladi, PINFL esa migratsiya bilan tozalangan."
  },
  "reviews": {
    "title": "Sharhlar",
    "subtitle": "Uchrashuvdan keyin qoldirilgan izohlar. Qoidaga zid sharh yashiriladi — o‘chirilmaydi.",
    "search": "Qidiruv",
    "searchPlaceholder": "Izoh matni yoki ism",
    "filter": "Holat",
    "filterAll": "Hammasi",
    "filterVisible": "Ko‘rinadigan",
    "filterHidden": "Yashirilgan",
    "empty": "Sharh topilmadi",
    "emptyHint": "Filtrni kengaytiring yoki qidiruvni o‘zgartiring.",
    "isHidden": "Yashirilgan",
    "hiddenBecause": "Sabab: {{reason}}",
    "hide": "Yashirish",
    "show": "Qaytarish",
    "hidden": "Sharh yashirildi",
    "shown": "Sharh qaytarildi",
    "hideConfirm": "Sharh ochiq sahifadan yo‘qoladi va mezbonning reytingidan chiqadi. O‘chirilmaydi — istalgan payt qaytarish mumkin.",
    "showConfirm": "Sharh ochiq sahifaga qaytadi va reytingga yana kiradi.",
    "reason": "Sabab",
    "reasonPlaceholder": "Masalan: haqorat, uchrashuvga aloqasi yo‘q",
    "reasonHint": "Kamida 10 belgi. Audit jurnaliga tushadi va sharh yonida ko‘rinib turadi."
  },
  "messages": {
    "title": "Xabarlar va e'lonlar",
    "subtitle": "Foydalanuvchiga yozing yoki hammaga e'lon bering. Xabar saytda va Telegramda ko‘rinadi.",
    "announceTitle": "Yangi e'lon",
    "audience": "Kimga",
    "audienceAll": "Hammaga",
    "audienceHosts": "Faqat mezbonlarga",
    "text": "Matn",
    "textPlaceholder": "Masalan: 20-sentabr 02:00 dan 04:00 gacha sayt texnik ishlar uchun yopiladi.",
    "textHint": "Matn TARJIMA QILINMAYDI — foydalanuvchiga aynan shu holida ko‘rinadi. Kamida 10, ko‘pi bilan 1000 belgi.",
    "send": "Yuborish",
    "confirmTitle": "E'lonni yuborish",
    "confirmHint": "Xabar minglab odamning telefoniga boradi va uni ORTGA QAYTARIB BO‘LMAYDI. Matnni oxirgi marta o‘qing.",
    "announceDone": "{{count}} foydalanuvchiga yuborildi",
    "filterAll": "Hammasi",
    "filterAnnouncements": "E'lonlar",
    "filterPersonal": "Shaxsiy",
    "types": {
      "admin_message": "Shaxsiy",
      "admin_announcement": "E'lon"
    },
    "reach": "{{total}} tadan {{read}} tasi o‘qigan",
    "empty": "Hali xabar yuborilmagan",
    "emptyHint": "Yuqoridagi shakl orqali e'lon bering yoki foydalanuvchi kartochkasidan shaxsiy xabar yozing.",
    "emptyHintRead": "Yuborilgan xabarlar shu yerda ko‘rinadi.",
    "toUser": "Xabar yozish",
    "toUserHint": "Xabar saytdagi bildirishnomalarga va (Telegram ulangan bo‘lsa) botga boradi.",
    "toUserDone": "Xabar yuborildi"
  }
}
